<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
                              Add Photo Assignment {{hsfo.huis_code }}
                            </v-card-title>
    <v-card-text>
    
                            <v-form ref="addHsfo" v-model="addHsfoValid">
      <v-row no-gutters>
        <v-col class="ma-2">
          Photo assignment will be created for this accommodation.         
        </v-col>  
      </v-row>  
      
      <v-row>  
          <v-col cols="6">
              <v-select label="Status" v-model="hsfo_status" :items="hsfo.hsfo_statusKeuzes" item-text="oms" item-value="value">
                  <template v-slot:item="data">
                      <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
                  <template v-slot:selection="data">
                      <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
              </v-select>
          </v-col>
          <v-col cols="6">
              <v-select label="Priority" v-model="hsfo_prio" :items="hsfo.hsfo_prioKeuzes" item-text="oms" item-value="value">
                  <template v-slot:item="data">
                      <v-chip :color='priocolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
                  <template v-slot:selection="data">
                      <v-chip :color='priocolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
              </v-select>
          </v-col>
      </v-row>
      
      
      
      <v-row>
        <v-col cols="6">
          <v-select label="Contact" v-model="hsfo_contact" :items="hsfo.contact_choices" item-text="eign_naam" item-value="eign_code">
              </v-select>
        </v-col>  
        <v-col cols="6">
          <v-select label="Photographer" v-model="hsfo_fotograaf" :items="hsfo.photographer_choices" item-text="gebr_naam" item-value="gebr_code">
              </v-select>
        </v-col>  
      </v-row>  
      <v-row>
        <v-col cols="6">
          <v-menu v-model="hsfo_deadlineMenu" :close-on-content-click="false"
          :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
          <template v-slot:activator="{ on }">
              <v-text-field v-model="hsfo_deadline" label="Deadline"
              v-on="on" dense></v-text-field>
          </template>
          <v-date-picker v-model="hsfo_deadline2" :first-day-of-week="1"
              @input="hsfo_deadline = $moment(hsfo_deadline2).format('DD-MM-YYYY');"></v-date-picker>
          </v-menu>
        </v-col>  

        <v-col cols="6">
          <v-text-field
              prefix="€"
              v-model="hsfo_vergoeding"
              type="number"
              label="Vergoeding"
              dense
            ></v-text-field>
        </v-col>
      </v-row>  

      <v-row>
        <v-col cols="12">
          <v-select label="Tasks" v-model="hsfo_hfot" :items="hsfo.hfot_typeKeuzes" item-text="oms" item-value="value" chips multiple>
              </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
              v-model="hsfo_description"
              label="Description"
              hint="Short description of the photo assignment"
              rows="3"
            ></v-textarea>
        </v-col>  
      </v-row>  

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHsfo" :disabled="!addHsfoValid" :loading="uploading">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false" :disabled="uploading">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      hsfo: { huis_code: '' },
      dialog: false,
      addHsfoValid: false,
      uploading: false,
      huis_encrid: null,
      hsfo_description: null,
      hsfo_deadline: null,
      hsfo_deadlineMenu: false,
      hsfo_deadline2: null,
      hsfo_fotograaf: null,
      hsfo_contact: null,
      hsfo_status: null,
      hsfo_prio: null,
      hsfo_vergoeding: null,
      hsfo_hfot: [],
      fttg_nrKeuzes: [],
      hsft_foto: null,
      hsft: {},
      url: null,
      image:{
        size:'',
        height:'',
        width:'',
        src: null
      },
      fttg_nrRules: [
          v => !!v || "A Tag is required"
      ],
      hsft_fotoRules: [
          v => !!v || "A photo is required"
      ],
      priocolor: {
        Low: '#D1E2FF',
        Medium: '#74EBE1',
        High: '#DC043B'
      },
      statuscolor: {
        Signedup: '#FAD2FC',
        Readytoshoot: '#FFEAB6',
        Offered: '#D1E2FF',
        Assigned: '#88DBFF',
        Completed: '#9AE095',
        Rejected: '#41454D',
        Onhold: '#FFB68E'
      },
      statuscolor_hfot: {
        Notapplicable: '#DC043B',
        Pending: '#D1E2FF',
        Completed: '#9AE095'
      }
    }
  },
  mounted() {   /* Work around voor Safari */
     let inputs = document.querySelectorAll('.v-file-input input');
         [...inputs].forEach((input) => {
              input.remove()
          })
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huis_encrid = huis_encrid;
      this.url = null;
      this.hsft_foto = null;
      this.$axios
        .post("ares/json/ares/huis/hsfo/getHuisToAddHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHsfo"
          },
          getHuisToAddHsfo: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfo = res.data.getHuisToAddHsfo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHsfo() {
      this.addHsfoValid = false;
      this.$axios
        .post("ares/json/ares/huis/hsfo/addHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHsfo"
          },
          addHsfo: {
            huis_encrid: this.huis_encrid,
            hsfo: this.hsfo,
            hsfo_description: this.hsfo_description,
            hsfo_deadline: this.hsfo_deadline,
            hsfo_fotograaf: this.hsfo_fotograaf,
            hsfo_contact: this.hsfo_contact,
            hsfo_status: this.hsfo_status,
            hsfo_prio: this.hsfo_prio,
            hsfo_vergoeding: this.hsfo_vergoeding,
            hsfo_hfot: this.hsfo_hfot
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            //  if (res.data.addHsft.color == "success") {
            //     //this.$router.reload('/huis/onHuis/' + res.data.addHsft.huis_encrid);  
            //     bus.$emit("closeDialog", "reload");
            //  }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHsfo.text,
              color: res.data.addHsfo.color
            });
            this.$emit('updateData');
            this.dialog = false;
            this.addHsfoValid = true;
          }
        })
    }
  }
}
</script>

